import { api } from './api';
import {
  TechnicalMessageAllResponse,
  TechnicalMessageDetailsResponse,
  TechnicalMessageSearchResponse,
} from './types';

export const technicalMessageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTechnicalMessage: builder.query<TechnicalMessageSearchResponse, any>({
      query: (params) => ({
        method: 'POST',
        url: `/api/technical-message/search`,
        body: params,
      }),
      providesTags: [{ type: 'TechnicalMessage', id: 'Message' }],
    }),

    getAllTechnicalMessage: builder.query<TechnicalMessageAllResponse, void>({
      query: () => ({
        method: 'GET',
        url: `/api/technical-message/all`,
      }),
    }),

    getTechnicalMessageCount: builder.query<number, void>({
      query: () => ({
        url: `/api/technical-message/status?isNew=true`,
      }),
      providesTags: [{ type: 'TechnicalMessage', id: 'Message' }],
    }),

    getTechnicalMessageDetails: builder.query<TechnicalMessageDetailsResponse, string>({
      query: (params) => ({
        url: `/api/technical-message/details?messageId=${params}`,
      }),
    }),

    addTechnicalMessage: builder.mutation<any, any>({
      query: (params) => ({
        url: `/api/technical-message/add`,
        method: 'POST',
        body: params,
      }),
    }),

    hideTechnicalMessage: builder.mutation<any, number>({
      query: (params) => ({
        url: `/api/technical-message/visited?messageId=${params}`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'TechnicalMessage', id: 'Message' }],
    }),
  }),
});

export const {
  useGetTechnicalMessageCountQuery,
  useGetTechnicalMessageQuery,
  useLazyGetTechnicalMessageQuery,
  useGetTechnicalMessageDetailsQuery,
  useHideTechnicalMessageMutation,
  useAddTechnicalMessageMutation,
} = technicalMessageApi;
